module.exports = __webpack_public_path__ + "img/icon-upload-succeed.902d25dc.png";